﻿import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { FormEvent, useState } from "react";
import { Button } from "react-bootstrap";
import { useAppContext } from "./AppContext";
import SignInWithMicrosoftSVG from "./SignInWithMicrosoftSVG" 

export interface IInfoFormProps {
    username: string;
    tenantId: string;
    email: string;
    startChat(userInfo: IUserInfo): any;
}
export interface IUserInfo {
    username: string;
    tenantId: string;
    email: string;
    metadata: Map<string, string>;
}

export default function InfoForm(props: IInfoFormProps) {
    const app = useAppContext();
    const user = app.user || undefined;
    const account = app.account || undefined;
    //console.log("user", user);
    //console.log("account", account);
    var tenantId = props.tenantId;
    var username2 = props.username;
    var email2 = props.email;
    var metadata = new Map<string, string>();
    if (user && account) {
        tenantId = account.tenantId;
        username2 = user.displayName || account.name || account.username;
        email2 = user.mail || account.username;
        metadata.set("Guest.GivenName", user.givenName || "");
        metadata.set("Guest.Surname", user.surname || "");
        metadata.set("Guest.UserPrincipleName", user.userPrincipalName || "");
        metadata.set("Guest.AadObjectId", user.id || "");
        metadata.set("Guest.Email", email2);
    }

    const [email, setEmail] = useState(email2);
    const [username, setUsername] = useState(username2);

    if (username2 !== username) {
        setUsername(username2);
    }
    if (email2 !== email) {
        setEmail(email2);
    }

    const onInputChange = (event: FormEvent<HTMLInputElement>) => {
        const target = event.currentTarget;
        var value = target.value;
        var id = target.id;
        if (id === "Guest.Name") {
            setUsername(value);
            props.username = value;
        } else if (id === "Guest.Email") {
            setEmail(value);
            props.email = value;
        }
    };
    const submit = (event: FormEvent) => {
        event.preventDefault();
        if (props.startChat) {
            props.startChat({
                tenantId: tenantId,
                email: email,
                username: username,
                metadata: metadata
            });
        }
    }

    return (
        <div style={{maxWidth: 420, paddingTop: "10%", margin: "0 auto"}}>
            <div className="card">            
                <form onSubmit={submit} className="card-body p-4 px-5">
                    <h5 className="mb-4">Welcome</h5>

                    <AuthenticatedTemplate>
                        <p className="mb-3">You've signed in. Click Start Chat to continue.</p>

                        <input type="hidden" id="Guest.TenantId" value={props.tenantId} />
                        <div className="mb-3">
                            {/* <label className="form-label" htmlFor="Guest.Name">Name</label> */}
                            <input type="text" id="Guest.Name" value={username} className="form-control"
                                readOnly={true} />
                        </div>
                        <div className="mb-3">
                            {/* <label className="form-label" htmlFor="Guest.Email">Email</label> */}
                            <input type="email" id="Guest.Email" value={email} className="form-control"
                                readOnly={true} />
                        </div>
                    </AuthenticatedTemplate>

                    <UnauthenticatedTemplate>
                        <p className="mb-3">Sign in with Microsoft to start a chat.</p>

                        <Button type="button" className="btn-primary border-0 bg-transparent p-0 mb-3" onClick={app.signIn!}>
                            <SignInWithMicrosoftSVG  />
                        </Button>

                        <p className="mb-3">Or please fill out the fields below.</p>
                        {/* <div className="mb-3">
                            <Button type="button" color="primary" onClick={app.signIn!}>Click here to sign in</Button>
                        </div> */}
                        <input type="hidden" id="Guest.TenantId" value={props.tenantId} />
                        <div className="mb-3">
                            {/* <label className="form-label" htmlFor="Guest.Name">Name</label> */}
                            <input type="text" id="Guest.Name" value={username} className="form-control"
                                onChange={onInputChange} placeholder="Name" />
                        </div>
                        <div className="mb-3">
                            {/* <label className="form-label" htmlFor="Guest.Email">Email</label> */}
                            <input type="email" id="Guest.Email" value={email} className="form-control"
                                onChange={onInputChange} placeholder="Email address" />
                        </div>

                    </UnauthenticatedTemplate>

                    <button type="submit" className="btn btn-primary">Start Chat</button>
                </form>
            </div>
        </div>
    );
}